export default "__VITE_ASSET__DQVkewLu__"